import { Injectable, signal } from '@angular/core';

/** The little "Saved · 14:32" confirmation. Fed by the save-toast
 *  interceptor for every successful write against the admin API, so every
 *  screen gets it without asking. */
@Injectable({ providedIn: 'root' })
export class SaveToastService {

  /** Time of the last save while the toast should show; null hides it. */
  readonly savedAt = signal<Date | null>(null);

  #timer: ReturnType<typeof setTimeout> | undefined;

  notify(): void {
    this.savedAt.set(new Date());
    clearTimeout(this.#timer);
    this.#timer = setTimeout(() => this.savedAt.set(null), 2600);
  }
}
